export const ONBOARDING_ENTITY = {
    ONBOARDING_CHAT: 'ONBOARDING-CHAT',
    ONBOARDING_JOURNEY: 'ONBOARDING-JOURNEY',
    MEDIA_PLAN: 'MEDIA_PLAN',
};
